export class PopularAccommodationsLoadError extends Error {
  readonly cause: unknown

  constructor(cause: unknown) {
    super('Error loading acco lister results')
    this.name = 'PopularAccommodationsLoadError'
    this.cause = cause
  }
}
